export const fontFamilies = [
  'Arial',
  'monospace',
  'Times New Roman',
  'Georgia',
  'Courier New',
  'Verdana',
] as const;
export const strokeTypes = ['None', 'Thin', 'Normal', 'Thick'] as const;

export const fontStyles = ['normal', 'bold', 'italic'] as const;

export const imageTypes = ['png', 'jpg', 'webp'] as const;
